import { VisibilityElement } from '@/components/custom-elements/visibility'

/**
 * IN VIEW CUSTOM ELEMENT
 * Handled as a custom element due to their being next to no state to manage, and due to how neatly it interacts with Tailwind
 *
 * For set up:
 *   1. Ensure you wrap your elements with <x-in-view>.
 *   2. Pass a 'data-target-id' to specify what component you're keeping track of.
 *   3. Use "gropu-data-visible:" for stateful styling.
 *
 */

export class InViewElement extends VisibilityElement {
  handleObserve: (entries: any) => void
  observer: IntersectionObserver | undefined

  constructor() {
    super()

    this.handleObserve = (entries) => {
      entries.forEach((entry: { isIntersecting: boolean }) => {
        if (entry.isIntersecting) {
          this.handleShow()
        } else {
          this.handleHide()
        }
      })
    }
  }

  connectedCallback() {
    super.connectedCallback()

    const targetElement = this.querySelector(`#${this.dataset.target}`)
    if (!targetElement) return
    this.observer = new IntersectionObserver(this.handleObserve)
    this.observer.observe(targetElement)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.observer?.disconnect()
  }
}
